import React from "react";

const Footer = () => {
	return (
		<div className="bg-dark p-3">
			<p className="text-center text-white text-brand">Design & Built by <a href="https://github.com/Fahimkhan9" target="__blank" rel='noopener noreferrer' className="text-decoration-none">Fahim Alif</a></p>
		</div>
	);
};

export default Footer;
